export const GetDashboardUrl = "/admin/api/dashboard";
